import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  min-height: 100vh;
  width: 100%;
  color: var(--primary);
  background-color: var(--secondary);

  @media (max-width: 600px) {
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 1200px) {
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: -2.5rem;
  position: relative;
  width: 100%;
`;

export const IconBox = styled.div`
  margin: 0rem 1rem;
  padding-top: 1rem;
  img{
    width: ${(props) => props.width ? css`${props.width}rem` : css`7rem`};
  }
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content:center;
  text-align: center
  margin: 0rem 1rem;
  padding-top: 1rem;
  img{
    width: ${(props) => props.width ? css`${props.width}rem` : css`4rem`};
  }
`;

export const ListContent = styled.div`
  display: flex;
  flex-direction: ${(props) => props.row ? css`row` : css`column`};
  align-items:center;
  justify-content:space-around;
  flex-wrap:wrap;
  width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 1rem;
`;

export const ListItem = styled.div`
  display: ${(props) => props.visible ? css`flex` : css`none`};
  flex-direction: ${(props) => props.row ? css`row` : css`column`};
  align-items:${(props) => props.align ? css`${props.align}` : css`center`};
  justify-content:${(props) => props.info ? css`space-between` : css`center`};
  ${(props) => props.justify && css`justify-content:${props.justify};`}
  flex-wrap:wrap;
  width: ${(props) => (props.divide ? css`${props.divide>2?98/3:98/props.divide}%` : props.reduct ? (css`${100-props.reduct}%`): css`100%`) };
  ${(props) => props.height && css`min-height: ${props.height}rem;`}
  margin: ${(props) => props.marTop ? css`${props.marTop}rem`: css`1rem`} 0 0 0;
  padding: ${(props) => props.padV ? css`${props.padV}rem`: css`1rem`} ${(props) => props.padW ? css`${props.padW}rem`:css`0rem`};
  cursor: ${(props) => props.pointer ? css`pointer` : css`auto`};
  ${(props) => props.border && css`border: 1px solid var(--primary);`}
  border-radius: ${(props) => props.roundborder ? css`10rem` : css`0rem`};
  background-color: ${(props) =>
    props.selected ? css`var(--darkBlue)` : css`var(--secondary)`};
  color: ${(props) =>
    props.selected ? css`var(--secondary)` : css`var(--primary)`};
  button {
    margin: 1rem 0;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  flex-wrap:nowrap;
  width: 80%;
  margin: 0;
  padding: 1rem;
  border: 0;
  background-color:var(--secondary);
  color:var(--primary);
  p {
    display: flex;
    width: 100%;
    flex-direction:row;
    flex-wrap:nowrap;
    align-items:center;
    justify-content:flex-start;
  }
  title{
    display: flex;
    width: 100%;
    flex-direction:row;
    flex-wrap:nowrap;
    align-items:center;
    justify-content:flex-start;
    font-weight: bold
  }
`;

export const Update = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  flex-wrap:nowrap;
  width: 100%;
  margin: 0 0 0.5rem 1rem;
  padding: 0;
  border: 0;
  background-color:var(--secondary);
  color:var(--gray);
`;

export const Button = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-end;
  justify-content:center;
  flex-wrap:nowrap;
  width: 20%;
  margin: 0;
  padding: 1rem;
  border: 0;
  background-color:var(--secondary);
  color:var(--primary);
`;

export const Title = styled.h1``;

export const Table = styled.table`
  width: 100%;
  margin: 0rem 0rem 2rem 0rem;
  border-collapse: collapse;
  
  tr{
    border: 1px solid black;
  }
  th{
    text-align: center;
    border: 1px solid black;
  }
  td{
    padding: 0rem 0.75rem;
    text-align: center;
    border: 1px solid black;
  }
  .cpfClass {
    min-width: 14rem;
  }
  .classeClass{
    min-width: 14rem;
  }
`;

export const JustifyList = styled.div`
  display: flex;
  flex-direction:column;
  width: 60rem;

  .LSL{
    background-color: #FFFF00;
    color: #000000;
  }
  .P{
    background-color:#FF9900;
    color: #000000;
  }
  .TRE{
    background-color:#00FFFF;
    color: #000000;
  }
  .AF{
    background-color:#351C75;
    color: #FFFFFF;
  }
  .GN{
    background-color:#000000;
    color: #FFFFFF;
  }
  .AP{
    background-color:#00FF00;
    color: #000000;
  }
  .I{
    background-color:#5B0F00;
    color: #FFFFFF;
  }
  .AA{
    background-color:#CC0000;
    color: #FFFFFF;
  }
  .LM{
    background-color:#45818E;
    color: #FFFFFF;
  }
  .LSD{
    background-color:#674EA7;
    color: #FFFFFF;
  }
  .LA{
    background-color:#6AA84F;
    color: #FFFFFF;
  }
  .LP{
    background-color:#46BDC6;
    color: #000000;
  }
  .ASV{
    background-color:#C27BA0;
    color: #000000;
  }
  .FE{
    background-color:#d6baa5;
    color: #000000;
  }
  .EX{
    border: 1px solid black;
  }
`;